import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProductsState } from '../../types/store';
import { IGetAllProductsResponse } from '../../types/api/response/productsresponse.d';
import { IProductSyncStatus } from '../../types/store.d';

const initialState: IProductsState = {
  content: [],
  page: {
    size: 20,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
  syncStatus: null,
};

const productsSlice = createSlice({
  name: 'productsSlice',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<IGetAllProductsResponse>) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    setProductSyncStatus: (state, action: PayloadAction<IProductSyncStatus>) => {
      state.syncStatus = action.payload;
    },
  },
});

export const { setProducts, setProductSyncStatus } = productsSlice.actions;

export default productsSlice.reducer;
